const USDTContract = "0x55d398326f99059fF775485246999027B3197955";// BNB Mainnet
//const USDTContract = "0xc2bEFff2b148FB54B017b133a0764ef4E7A72dcA";// BNB TestNet
const BNBUSDTContract = "0x7bC56a63C05a2FF7a14cF9a3DaC85CC60892ED54";

export {
  BNBUSDTContract,USDTContract
};

